import Vue from 'vue'
import * as toastr from 'toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import QuickWarehouseShift from '../../component/view/QuickWarehouseShift.vue'
import SingleSelect from '@component/singleselect.vue'

if ($('#warehouse_work_order_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#warehouse_work_order_form',
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      SimpleSingleselect,
      Multiselect,
      Datepicker,
      moment,
      QuickWarehouseShift,
      SingleSelect,
    },
    mixins: [mixins],
    data: {
      generatingForTemporary: false,
      loading: 0,
      quickShiftCounter: 0,
      quickLoading: 0,
      date: moment().toDate(),
      generationDate: moment().subtract(1, 'days').toDate(),
      teams: [],
      assignedMeals: [],
      hours: [],
      caretDownClass: 'fa-caret-down',
      caretUpClass: 'fa-caret-up',
      visibleTeams: [],
      pendingAssignations: {},
      assignTeamColors: {},
      teamCounters: {},
      teamCountersText: {},
      quickShifts: [],
      warehouses: [],
      materials: [],
      materialsNotFiltered: [],
      meals: [],
      finalMeals: [],
      generatedShifts: [],
      errors: [],
      checkedAssignedTeams: [],
      hourToAssign: null,
      selectTeam: null,
      collectionTeams: [],
      selectedTeam: null,
      countAssignMeals: 0,
      isCheckedAll: false,
    },
    computed: {
      activeTeams: function () {
        return this.teams
      },
      errorModalTitle: function () {
        if (this.generatingForTemporary) {
          return 'Status możliwości planowania ruchów magazynowych'
        }
        return 'Status możliwości wygenerowania ruchów magazynowych'
      },
      selectedPendingAssignations: function () {
        let selected = {}
        for (let teamId in this.pendingAssignations) {
          if (this.checkedAssignedTeams.includes(parseInt(teamId))) {
            selected[teamId] = this.pendingAssignations[teamId]
          }
        }
        return selected
      }
    },
    watch: {
      date: function (newDate) {
        this.generationDate = moment(newDate).subtract(1, 'days').toDate()
      },
      loading: {
        handler: function (newLoading, oldLoading) {
          if (newLoading === 0 && oldLoading > 0) {
            $(document).ready(() => {
              $('.to-show').show()
            })
            this.setAssignTeamColors()
            this.updateTeamSelections()
          }
        }
      },
      quickShifts: function (newQuickShifts) {
        if (newQuickShifts.length === 0) {
          this.addQuickShift()
        }
      },
      quickLoading: {
        handler: function (newLoading, oldLoading) {
          if (newLoading === 0 && oldLoading > 0) {
            $(document).ready(() => {
              $('.to-show-2').show()
            })
            if (this.generatedShifts.length > 0) {
              this.showSummaryModal()
            }
          }
        }
      },
      selectedTeam: function () {
        this.isCheckedAll = false
        this.checkAll()
      }
    },
    mounted: function () {
      this.createHours()
      this.fetchWarehouses()
      this.fetchMaterials()
      this.fetchMeals()
      this.fetchFinalMeals()
      this.addQuickShift(),
      this.getTeams()
    },
    methods: {
      closeSummaryModal: function () {
        $('#summaryModal').modal('hide')
        this.generatedShifts = []
      },
      showSummaryModal: function () {
        $('#summaryModal').modal()
      },
      closeErrorModal: function () {
        $('#errorModal').modal('hide')
        this.errors = []
      },
      showErrorModal: function () {
        $('#errorModal').modal()
      },
      isHourSelected: function (assignedMeal, hour) {
        if (assignedMeal.time !== null) {
          return assignedMeal.time === hour
        }
        if (typeof this.pendingAssignations[assignedMeal.assignTeamId] !== 'undefined') {
          return this.pendingAssignations[assignedMeal.assignTeamId] === hour
        } else {
          return false
        }
      },
      setAssignTeamColors: function () {
        this.assignedMeals.forEach((assignedMeal) => {
          this.assignTeamColors[assignedMeal.assignTeamId] = this.getAssignTeamColor(assignedMeal)
        })
      },
      getAssignTeamColor: function (assignedMeal) {
        if (assignedMeal.temporaryShiftGenerated === true) {
          return '#CAFFEA'
        } else if (assignedMeal.shiftGenerated === true) {
          return '#69FFC3'
        } else {
          return '#F1BBC8'

        }
      },
      updateTeamSelections: function () {
        let self = this
        this.teamCounters = {
          selected: this.teamCounters ? this.teamCounters.selected : 0,
          all: self.assignedMeals ? self.assignedMeals.length : 0
        }
        this.teamCountersText = `${this.teamCounters.selected}/${this.teamCounters.all}`
        $('#team-counter').html(this.teamCountersText)
        this.$forceUpdate()
      },
      setMealProductionHour: function (hour, assignedMeal/*, teamId*/) {
        let assignTeamId = assignedMeal.assignTeamId
        if (hour === 'null') {
          hour = null
        }
        this.pendingAssignations[assignTeamId] = hour
        let setHourTeams = Object.keys(this.pendingAssignations)

        this.teamCounters.selected =
            this.assignedMeals.filter(ml =>
              (
                ml.time !== null || (this.pendingAssignations[ml.assignTeamId] !== null
                && ml.checked === true
                && setHourTeams.includes(ml.assignTeamId.toString()))
              )
            ).length
        this.updateTeamSelections()
        this.refresh()

      },
      createHours: function () {
        let hours = [...Array(24).keys()]
        let minutes = ['00', '15', '30', '45']
        hours.forEach((hour) => {
          minutes.forEach((minute) => {
            if (hour.toString().length < 2) {
              hour = `0${hour.toString()}`
            }
            this.hours.push(`${hour}:${minute.toString()}`)
          })
        })
      },
      getColorClass: function () {
        return { background: 'lightgreen' }
      },
      isSameAsInitialHour: function (teamId, assignTeamId, hour) {
        let assignedMeals = this.assignedMeals
        let assignedMeal = null
        assignedMeals.forEach((assignedMealIt) => {
          if (assignedMealIt.assignTeamId === assignTeamId) {
            assignedMeal = assignedMealIt
          }
        })
        return assignedMeal && assignedMeal.time === hour
      },
      setInitialState: function () {
        this.teams = []
        this.assignedMeals = []
        this.pendingAssignations = {}
        this.assignTeamColors = {}
        this.teamCounters = {}
        this.teamCountersText = {}
        this.checkedAssignedTeams = []
        this.countAssignMeals = 0
      },
      getInnerMeals: function (meals, mealIdTrace, alreadyUsed = []) {
        let compare = `c_${mealIdTrace.join('_')}`
        let innerMeals = meals.filter(meal => {
          return meal.uid.includes(compare) && !mealIdTrace.includes(meal.mealId) && !alreadyUsed.includes(meal)
        })
        return innerMeals.sort((mealA, mealB) => {
          let bigger = mealA.uid > mealB.uid
          let smaller = mealA.uid < mealB.uid
          if (bigger) {
            return 1
          }
          if (smaller) {
            return -1
          }
          return 0
        })
      },
      sortAssignedMeals: function (assignedMeals) {
        let teamFinalMeals = {}

        assignedMeals.forEach(meal => {
          if (meal.uid.includes('f_')) {
            teamFinalMeals[meal.uid.replace('f_', '')] = meal
          }
        })

        let teamMeals = []
        for (let finalMealId in teamFinalMeals) {
          teamMeals.push(teamFinalMeals[finalMealId])
          this.getInnerMeals(assignedMeals, [finalMealId]).forEach(meal => {
            teamMeals.push(meal)
          })
        }

        assignedMeals.filter(obj => !teamMeals.includes(obj)).forEach(meal => {
          teamMeals.push(meal)
        })
        assignedMeals = teamMeals

        return assignedMeals
      },
      fetchTeams: function (date, id) {
        this.setInitialState()
        this.loading += 2
        let dateFormatted = moment.utc(date).format('Y-M-D')

        let assignedTeamsUrl = Routing.generate('api_get_assign_teams', {
          date: dateFormatted,
          teamId: id
        })

        let teamsUrl = Routing.generate('api_get_team', { id: id })
        axios.get(teamsUrl).then((response) => {
          this.teams = response.data
          this.loading--
        })
        axios.get(assignedTeamsUrl).then((response) => {
          this.assignedMeals = response.data

          this.teamCounters = { selected: 0,
            all: 0 }

          this.assignedMeals.forEach((assignedMeal) => {
            if (assignedMeal.time !== null) {
              this.teamCounters.selected++
            }
          })

          this.assignedMeals = this.sortAssignedMeals(this.assignedMeals)
          this.countAssignMeals = this.assignedMeals ? this.assignedMeals.length : 0

          if (this.countAssignMeals === 0) {
            toastr.info(
              'Nie znaleziono posiłków przypisanych do zeposłu.',
              null,
              { timeOut: 5000 }
            )
          }
          this.loading--
        })
      },
      formatMeal: function (assignedMeal) {
        let prefix = ''
        if (assignedMeal.type === 'final_meal') {
          prefix = 'PK'
        } else {
          prefix = 'PS'
        }
        let unit = ''
        if (assignedMeal.unit === 'mass') {
          unit = 'kg'
        } else {
          unit = 'szt.'
        }
        return `${prefix} - ${assignedMeal.mealName} ${assignedMeal.quantity} ${unit}`
      },
      saveTemporaryHours: function () {
        this.saveHours(false, true)
      },
      checkAssignedMeal: function (assignedMeal, check) {
        let currentHour = this.pendingAssignations[assignedMeal.assignTeamId]
        currentHour = typeof currentHour === 'undefined' ? null : currentHour
        if (check === true) {
          if (!this.checkedAssignedTeams.includes(assignedMeal.assignTeamId)) {
            this.checkedAssignedTeams.push(parseInt(assignedMeal.assignTeamId))
          }
        } else {
          this.checkedAssignedTeams = this.checkedAssignedTeams.filter(el => el !== assignedMeal.assignTeamId)
        }
        assignedMeal.checked = check
        this.setMealProductionHour(currentHour, assignedMeal)
        if (check === true && assignedMeal.type === 'final_meal') {
          this.assignedMeals.forEach(aMeal => {
            if (aMeal.uid.includes(`c_${assignedMeal.mealId}`) && aMeal.shiftGenerated === false) {
              this.checkAssignedMeal(aMeal, true)
            }
          })
        }
        this.refresh()
      },
      saveHours: function (checkOnly = false, temporary = false) {
        this.generatingForTemporary = temporary
        if (checkOnly) {
          this.errors = []
        }
        if (this.errors.length > 0) {
          return
        }
        this.closeErrorModal()
        this.loading++
        let request = {}
        request.teams = []
        request.checkOnly = checkOnly
        request.temporary = temporary
        let route = Routing.generate('api_update_warehouse_shift_work_orders')
        let dateFormatted = moment(this.generationDate).format('YYYY-MM-DD')
        for (let teamId in this.pendingAssignations) {
          if (!this.checkedAssignedTeams.includes(parseInt(teamId))) {
            continue
          }

          let currentTeam = this.findAssignedTeamById(teamId)

          let time = ( this.pendingAssignations[teamId] ? this.pendingAssignations[teamId] : (currentTeam ? currentTeam.time : null))
          if (time !== null && time !== 'null') {
            request.teams.push({
              id: teamId,
              time: `${dateFormatted} ${time}`
            })
          }
        }
        if (request.teams.length === 0) {
          toastr.info('Nie wybrano żadnych zleceń')
          this.loading--
          return
        }
        this.$http.post(route, request).then(() => {
          if (!request.checkOnly) {
            this.fetchTeams(this.date, this.selectedTeam)
          } else {
            this.showErrorModal()
            this.errors = []
          }
        }).catch(response => {
          if (response.status === 500) {
            this.errors.push('Wystąpił niezidentyfikatowany błąd serwera')
          } else {
            this.errors = response.data.messages
          }
          this.showErrorModal()
        }).finally(() => {
          this.loading--
        })
      },
      findAssignedTeamById: function (id) {
        let data = this.assignedMeals.find(assignedTeam => assignedTeam.assignTeamId === parseInt(id))
        if (typeof data !== 'undefined') {
          return data
        }
        return null
      },
      saveQuickShifts: function () {
        this.quickLoading++
        let route = Routing.generate('api_material_warehouse_shift_warehouse_shift')
        let shifts = this.quickShifts
        this.quickShifts = []
        shifts.forEach((quickShift, index, array) => {
          delete quickShift.errors
          this.quickLoading++
          let data = {}
          data.data = {}
          for (let field in quickShift) {
            if (field === 'dateExpected') {
              data.data[field] = this.getDateForQuickShift(quickShift.dateExpected)
            } else {
              data.data[field] = quickShift[field]
            }
          }
          this.$http.post(route, data).then((response) => {
            array.splice(index, 1)
            this.generatedShifts.push({
              shifts: response.body.shifts,
              data: data.data
            })
            toastr.success('Wygenerowano ruchy magazynowe')
          }).catch(response => {
            if ('message' in response.data) {
              toastr.error(response.data.message)
            } else {
              quickShift.errors = response.data.errors
            }
          }).finally(() => {
            this.quickLoading--
          })
        })
        this.quickShifts = shifts
        this.quickLoading--
      },
      fetchMeals: function () {
        this.quickLoading++
        this.$http.get(Routing.generate('api_get_meals', { context: 'quick_shift' })).then(response => {
          this.meals = response.data
          this.quickLoading--
        })
      },
      fetchFinalMeals: function () {
        this.quickLoading++
        this.$http.get(Routing.generate('api_get_meal_meals_for_quick_shift', { context: 'quick_shift' })).then(response => {
          this.finalMeals = response.data
          this.quickLoading--
        })
      },
      fetchMaterials: function () {
        this.quickLoading++
        this.$http.get(Routing.generate('api_get_materials', { context: 'quick_shift' })).then(response => {
          this.materialsNotFiltered = response.data.filter(material => {
            return (typeof material.products !== 'undefined' && material.products.length > 0)
          })
          this.materials = response.data.filter(material => {
            return !material.notStoredInWarehouse &&
                            !material.notIncludedInWarehouseShifts &&
                            (typeof material.products !== 'undefined' && material.products.length > 0)
          })
          this.quickLoading--
        })
      },
      fetchWarehouses: function () {
        this.quickLoading++
        this.$http.get(Routing.generate('api_get_warehouses', { context: 'quick_shift' })).then(response => {
          this.warehouses = response.data
          this.quickLoading--
        })
      },
      addQuickShift: function () {
        this.quickShifts.push(
          {
            rowId: this.quickShiftCounter++,
            material: null,
            dateExpected: moment().format('HH:mm'),
            warehouseFrom: null,
            warehouseTo: null,
            meal: null,
            amountExpected: 1,
            description: null
          }
        )
      },
      deleteQuickShift: function (quickShift) {
        this.quickShifts = this.quickShifts.filter(qS => {
          return qS.rowId !== quickShift.rowId
        })
      },
      getDateForQuickShift: function (time) {
        let now = moment()
        let wantedDate = moment(`${now.format('YYYY-MM-DD')} ${time}`, 'YYYY-MM-DD HH:mm')
        if (wantedDate.isAfter(now.format('YYYY-MM-DD HH:mm'))) {
          return wantedDate.format('YYYY-MM-DD HH:mm')
        } else {
          return wantedDate.add(1, 'days').format('YYYY-MM-DD HH:mm')
        }
      },
      getShiftUrl: function (id) {
        return Routing.generate('warehouse_shift_show', { id })
      },
      getMealById: function (id) {
        let meal = this.meals.find(meal => meal.id === id)
        if (meal) {
          return meal.name
        }
        return ''
      },
      getMaterialById: function (id) {
        let material = this.materialsNotFiltered.find(material => material.id === id)
        if (material) {
          return material.name
        }
        return ''
      },
      getUnit: function (unit) {
        switch (unit) {
          case 'piece':
            return 'szt.'
          case 'mass':
            return 'kg'
          default:
            return unit
        }
      },
      setMassHour: function () {
        this.assignedMeals.forEach(assignedMeal => {
          if (assignedMeal.checked === true) {
            if (assignedMeal.time !== null) {
              if (this.hourToAssign !== null && this.hourToAssign !== 'null') {
                assignedMeal.time = this.hourToAssign
              }
            } else {
              this.setMealProductionHour(this.hourToAssign, assignedMeal)
            }
          }
        })
      },
      generateMaterialAssembleList: function (isMerge, teamId) {
        this.errors = []
        this.loading++

        const teamAssignMeal = {}
        const mealIds = this.assignedMeals.filter(
          element => element.type === 'final_meal' && element.checked === true
        ).map((item) => {
          return item.mealId
        })

        if (mealIds.length) {
          teamAssignMeal[teamId] = mealIds
        }

        if (Object.keys(teamAssignMeal).length === 0) {
          toastr.info('Nie wybrano żadnego posiłku końcowego')
          this.loading--
          return
        }

        const data = {
          teamAssignMeal: teamAssignMeal,
          deliveryDate: moment.utc(this.date).format('YYYY-MM-DD'),
          isMerge: isMerge,
        }

        window.location.replace(Routing.generate('api_generate_material_assemble_list', data))

        this.loading--
      },
      getTeams() {
        this.loading++
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.collectionTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      checkAll() {
        this.assignedMeals.forEach((assignedMeal) => {
          this.checkAssignedMeal(assignedMeal, this.isCheckedAll)
        })
      },
      showAssignTeam() {
        if (this.selectedTeam) {
          this.fetchTeams(this.date, this.selectedTeam)
        } else {
          toastr.error('Nie wybrano zespołu.')
        }
      }
    }
  })
}
